import { combineDateAndTimeWithLocalTimezone } from "./combineDateAndTime";

export const searchNextDate = (date: Date, hour: string): {return_date: Date; return_hour: string} => {
    const return_date: Date = combineDateAndTimeWithLocalTimezone(date, hour) as Date;
    return_date.setHours(return_date.getHours() + 2);
    const return_hour = return_date.getHours().toString().padStart(2, '0') + 'h';

    return { return_date, return_hour };
}